import { CommonModule } from '@angular/common';
import { Component, inject, OnInit, ViewChild } from '@angular/core';
import { MatButton } from '@angular/material/button';
import { MatListModule } from '@angular/material/list';
import { MatProgressBar } from '@angular/material/progress-bar';
import { RouterModule } from '@angular/router';
import { MatMenuModule } from '@angular/material/menu';

import { MatIcon } from '@angular/material/icon';
import { environment } from '../../environments/environment';
import { AccountService } from '../core/services/account-service';
import { Navlink } from '../core/models/Navlink';
import { BusyService } from '../core/services/busy-service';
import { HomePageLink } from '../util/constant';

@Component({
  selector: 'app-header',
  imports: [
    CommonModule,
    MatListModule,
    RouterModule,
    MatButton,
    MatMenuModule,
    MatProgressBar,
  ],
  templateUrl: './header.html',
  styleUrl: './header.scss',
})
export class HeaderComponent implements OnInit {
  isProduction = environment.production;
  accountService = inject(AccountService);
  busyService = inject(BusyService);
  midLinks: Navlink[] = [];
  showHeader = true;

  ngOnInit(): void {
    window.addEventListener('scroll', () => {
      this.showHeader = window.scrollY < 137;
    });

    this.accountService.getUser();
    this.accountService.user$.subscribe((user) => {
      const newLinks: Navlink[] = [
        // HomePageLink,
        {
          title: 'New Request',
          path: '/new-request',
        },
        {
          title: 'In-Process Requests',
          path: '/in-process',
        },
        {
          title: 'Archived Requests',
          path: '/archived-requests',
        },
        {
          title: 'Reports',
          path: '/reports',
        },
      ];
      // if (user?.roles.some((r) => r.name == 'Admin')) {
      //   newLinks.push(...adminMidLinks);
      // } else if (user?.jobTitle.department.name) {
      //   switch (user.jobTitle.department.name) {
      //     case HullDesignDepartment:
      //       newLinks.push(hullDesignLink);
      //       break;
      //     case 'Planning':
      //       newLinks.push(productionLink);
      //       break;
      //     case 'Production':
      //       newLinks.push(productionLink);
      //       break;
      //     case 'Prime Plate':
      //     case 'Prefabrication':
      //       newLinks.push(productionLink);
      //       break;
      //     case QualityDepartment:
      //       newLinks.push(productionLink);
      //       break;
      //     case ProcurementDepartment:
      //       newLinks.push(procurementLink);
      //       break;
      //     // case 'Procurement':
      //     //   newLinks.push();
      //     //   break;
      //     default:
      //       break;
      //   }
      // }
      this.midLinks = newLinks;
    });
  }

  isActive(path: string): boolean {
    return location.pathname === path;
  }
}
